import { useContext } from 'react';
import { I18nContext, type I18nContextType } from '@/i18n/I18nProvider';

export function useI18n(): I18nContextType {
  const ctx = useContext(I18nContext);
  if (!ctx) {
    throw new Error('useI18n must be used within an I18nProvider');
  }
  return ctx;
}
